import { createContext } from "use-context-selector";
import { GlobalSiteSettingsContextType } from "./useActions";

const GlobalSiteSettingsContext = createContext<GlobalSiteSettingsContextType>(null!);

export default GlobalSiteSettingsContext;
